import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BulkImportMeta } from '@app/modules/reporting/interfaces/bulk-import-meta-data.interface';
import { BULK_IMPORT_META_DATA } from '@reporting/views/bulk-import/bulk-import-config';
import { AuthService, FileHelperService, NotifyService } from 'app/services/index';

@Component({
    templateUrl: './bulk-import-entity.view.html',
    styleUrls: ['./bulk-import-entity.style.scss'],
})
export class BulkImportEntityView implements OnInit {
    isLoading = false;
    isProcessing = false;
    file: File;
    entity: BulkImportMeta;

    readonly importMetaData = BULK_IMPORT_META_DATA;

    constructor(
        private activatedRoute: ActivatedRoute,
        private auth: AuthService,
        private notify: NotifyService,
        private fileService: FileHelperService
    ) {}

    ngOnInit(): void {
        this.setEntityFromRoute();
    }

    async import(): Promise<void> {
        this.isLoading = true;

        try {
            const fileId = (await this.fileService.store(this.file)).id;

            const importModel = new this.entity.importModel({
                context: 'import',
                fileId: fileId,
            });

            await importModel.param('company', this.auth.company.id).save();

            this.isProcessing = true;
            this.notify.success('reporting.data-import.processingTheData');
        } catch (e) {
            this.notify.error('reporting.data-import.thereWasAnErrorProcessingTheData');
        }

        this.isLoading = false;
    }

    private setEntityFromRoute(): void {
        this.entity = this.importMetaData.find(
            (entity) => entity.routerLink === this.activatedRoute.snapshot.params.entity
        );
        if (!this.entity) {
            this.notify.error('reporting.data-import.couldNotFindTheImportTemplate');
            return;
        }
    }
}
